import script from "./StatTypeTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./StatTypeTasks.vue?vue&type=script&setup=true&lang=js"

import "./StatTypeTasks.vue?vue&type=style&index=0&id=bb7968ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb7968ba"]])

export default __exports__